import es from './es';
import pt from './pt';
import de from './de';
import nl from './nl';
import { isCountrySpain, isCountryPortugal, isCountryGermany, isCountryNetherlands } from 'utilities/multiLanguageHelper';

export const generatePdf = urlsPdfs => {
    if (isCountrySpain()) return es.generatePdf(urlsPdfs);
    else if (isCountryPortugal()) return pt.generatePdf(urlsPdfs);
    else if (isCountryGermany()) return de.generatePdf(urlsPdfs);
    else if (isCountryNetherlands()) return nl.generatePdf(urlsPdfs);

    return es.generatePdf();
};
